<motif-modal-title>
  <h3 class="motif-body1-default-regular m-0">{{ AddDeliverablesTitle }}</h3>
  <button type="button" class="modal-close-btn" aria-label="Close modal" [motif-modal-close]="true">
    <motif-icon
      class="motif-modal-header-close-icon"
      var="--navigation-Ic-Close-48px"
      aria-hidden="true"></motif-icon>
  </button>
</motif-modal-title>

<motif-modal-content>
  <div class="right-slide-model-wrapper">
    <div
      class="d-flex flex-column gap-4 align-items-start justify-content-start">
      <div
        class="d-flex flex-column gap-1 align-items-start justify-content-start w-100">
        <motif-form-field class="w-100">
          <label motifLabel>{{
            this.AddDeliverablesHeaders.DeliverableType.Name
          }}</label>
          <motif-select
            labelPosition="inside"
            aria-label="Select deliverable type"
            [(ngModel)]="selectedDeliverableType"
            selectTitle="Select deliverable type"
            placeholder="{{
              this.AddDeliverablesHeaders.DeliverableType.Placeholder
            }}"
            (selectionChange)="onSelectDeliverableType($event)"
            aria-required="true"
            [required]="true">
            <motif-option *ngFor="let type of deliverableTypes" [value]="type">
              {{ type.deliverableTypeName }}
            </motif-option>
          </motif-select>
        </motif-form-field>
      </div>
      <div
        class="d-flex flex-column gap-1 align-items-start justify-content-start w-100">
        <motif-form-field class="w-100">
          <label motifLabel
            >{{ AddDeliverablesHeaders.ProcessName.Name }}
              <span class="required-text"> (required)</span>
          </label>
          <input
            motifInput
            labelPosition="inside"
            type="text"
            [(ngModel)]="processName"
            aria-label="Process Name"
            maxlength="150"
            [required]="true" />
        </motif-form-field>
        <div *ngIf="isProcessNameInvalid" class="sa-error-msg">
          Special characters are not allowed.
        </div>
        <div class="description-char-count">
          {{ processName.length || 0 }} / 150
        </div>       
      </div>

      <div
        class="d-flex flex-column gap-1 align-items-start justify-content-start w-100">
        <motif-form-field class="w-100">
          <label motifLabel>{{
            this.AddDeliverablesHeaders.Description.Name
          }}</label>
          <textarea
            motifInput
            labelPosition="inside"
            type="text"
            [(ngModel)]="description"
            rows="8"
            maxlength="255"
            style="min-height: 120px"
            placeholder="Enter a description..."
            aria-label="Description"></textarea>
        </motif-form-field>
        <div *ngIf="isDescriptionInvalid" class="sa-error-msg">
          Special characters are not allowed.
        </div>
        <div class="description-char-count">
          {{ description.length || 0 }} / 255
        </div>
      </div>
     
     
    </div>
  </div>
</motif-modal-content>

<motif-modal-actions>
  <button
    motifButton
    motif-modal-close
    color="secondary"
    aria-label="Cancel"
    role="button">
      {{ this.AddDeliverablesButtonTexts.CancelButton }}
  </button>
  <button
    motifButton
    color="primary"
    aria-label="Create"
    (click)="onCreate()" 
    [disabled]="isCreateDisabled" 
    role="button">
      {{ this.AddDeliverablesButtonTexts.CreateButton }} 
  </button>
</motif-modal-actions>